import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import { UtilisationSettings } from '@/components/UtilisationSettings';
import { TabAccessAlerts } from './TabAccessAlerts';
import type { SettingsFormState } from '../hooks/useSettingsFormState';
import type { UtilisationSettings as UtilisationSettingsType } from '@/types/timesheetSettings';

interface UtilisationTabProps {
  form: SettingsFormState;
  utilisationSettings: UtilisationSettingsType;
  canEditUtilisation: boolean;
}

export const UtilisationTab: React.FC<UtilisationTabProps> = ({
  form,
  utilisationSettings,
  canEditUtilisation,
}) => {
  const { tabsWithChanges, handleUtilisationChange } = form;

  return (
    <TabsContent value="utilisation" className="space-y-6">
      <TabAccessAlerts
        canEdit={canEditUtilisation}
        hasChanges={tabsWithChanges.has('utilisation')}
        viewOnlyText="You have view-only access to Utilisation. Contact your administrator to request edit access."
        unsavedText={'You have unsaved changes. Click "Save Settings" to apply your changes.'}
      />

      <UtilisationSettings
        settings={utilisationSettings}
        onChange={handleUtilisationChange}
      />
    </TabsContent>
  );
};
